import React from 'react';
import cn from "classnames";

type Props = {
    hidden?: boolean;
    className?: string;
    text?: string;
};

export default function Divider(props: Props) {

    const hidden = props.hidden !== undefined ? props.hidden : false;

    const dividerCn = cn(
        "border-b h-px relative",
        props.className,
    );

    return (
        <div className={dividerCn} hidden={hidden}>
            &nbsp;
            <div className={"absolute -top-[14px] text-center w-full"}>
                {props.text && (
                    <span className={"bg-white px-2 font-extralight lowercase"}>{props.text}</span>
                )}
            </div>
        </div>
    );
}